// removed by extract-text-webpack-plugin
module.exports = {"popUp":"WBbM5Q9zHCepQpExEnR6h"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/PaymentMethods/styles.css
// module id = 1476
// module chunks = 0